/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFilterCog = createReactComponent("filter-cog", "IconFilterCog", [
  [
    "path",
    {
      d: "M12 20l-3 1v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v1.5",
      key: "svg-0"
    }
  ],
  ["path", { d: "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-1" }],
  ["path", { d: "M19.001 15.5v1.5", key: "svg-2" }],
  ["path", { d: "M19.001 21v1.5", key: "svg-3" }],
  ["path", { d: "M22.032 17.25l-1.299 .75", key: "svg-4" }],
  ["path", { d: "M17.27 20l-1.3 .75", key: "svg-5" }],
  ["path", { d: "M15.97 17.25l1.3 .75", key: "svg-6" }],
  ["path", { d: "M20.733 20l1.3 .75", key: "svg-7" }]
]);

export { IconFilterCog as default };
//# sourceMappingURL=IconFilterCog.js.map
